import Request from "./Request";

export const getLogs = (filters = {}, id) => {
  console.log(id);
  return Request(true).get("/log/" + id, {
    params: filters
  });
};
